var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6791 11.8964L14.8444 14.0605C14.9454 14.1651 15.0012 14.3051 15 14.4505C14.9987 14.5958 14.9404 14.7349 14.8376 14.8376C14.7349 14.9404 14.5958 14.9987 14.4505 15C14.3051 15.0012 14.1651 14.9454 14.0605 14.8444L11.8953 12.6791C10.4803 13.8914 8.65079 14.5085 6.79063 14.401C4.93047 14.2935 3.18426 13.4697 1.91841 12.1024C0.652558 10.7351 -0.0345236 8.93074 0.00133627 7.06782C0.0371961 5.20489 0.79321 3.42827 2.11074 2.11074C3.42827 0.79321 5.20489 0.0371961 7.06782 0.00133627C8.93074 -0.0345236 10.7351 0.652558 12.1024 1.91841C13.4697 3.18426 14.2935 4.93047 14.401 6.79063C14.5085 8.65079 13.8914 10.4803 12.6791 11.8953V11.8964ZM7.2066 13.3044C8.82384 13.3044 10.3748 12.662 11.5184 11.5184C12.662 10.3748 13.3044 8.82384 13.3044 7.2066C13.3044 5.58936 12.662 4.03835 11.5184 2.89479C10.3748 1.75123 8.82384 1.10878 7.2066 1.10878C5.58936 1.10878 4.03835 1.75123 2.89479 2.89479C1.75123 4.03835 1.10878 5.58936 1.10878 7.2066C1.10878 8.82384 1.75123 10.3748 2.89479 11.5184C4.03835 12.662 5.58936 13.3044 7.2066 13.3044Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.c563637fd084cd72f3dfc3e46a12e8ee.svg";
export { ForwardRef as ReactComponent };